import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { Keys } from 'app/models/core/dropdowns';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabApplicationMenuService } from 'app/services/application-menu/lab-application-menu.service';
import { SharedService } from '@shared/services/shared.service';
import { IApplicationTechnologyReport, IApplicationTechnologyViewModel, IFoaReportViewModel } from 'app/models/reports/reports';

@Component({
  selector: 'foaReport',
  templateUrl: './foaReport.component.html',
  styleUrls: ['./foaReport.component.scss']
})
export class FoaReportComponent {
  
  @ViewChild('pdf') pdf: PDFExportComponent;
  public techData: IFoaReportViewModel [] = [];
  public groupedTechnologies: { matrix: string, foaList: { method: string, foas: IFoaReportViewModel[] }[] }[] = [];
  public orelapId: string = '';
  public epaId: string = '';
  public appId: string = '';

  constructor(public searchLabsService: SearchLabsService,
    public settings: SettingsService,
    private dialogRef: MatDialogRef<FoaReportComponent>,
    private labApplicationMenuService: LabApplicationMenuService,
    private sharedService: SharedService
  ) {
    this.labApplicationMenuService.getFoaReport(this.sharedService.currentApplication.labId).subscribe(
      response => {
        this.techData = response;
        this.groupTechnologies(this.techData);
        this.orelapId = this.techData[0]?.orelapId || '';
        this.epaId = this.techData[0]?.epaId || '';
        this.appId = this.techData[0]?.appId.toString() || '';
      },
      error => console.log('error', error)
    );
  }

  groupTechnologies(technologies: IFoaReportViewModel[]): void {
    // First group by name
    const byMatrix: { [key: string]: IFoaReportViewModel[] } = {};
    technologies.forEach(tech => {
      if (!byMatrix[tech.matrix]) {
        byMatrix[tech.matrix] = [];
      }
      byMatrix[tech.matrix].push(tech);
    });

    // Then group each name by instrumentTechnology
    this.groupedTechnologies = Object.keys(byMatrix).map(matrix => {
      const methodsForMatrix = byMatrix[matrix];
      const byMethods: { [key: string]: IFoaReportViewModel[] } = {};
      
      methodsForMatrix.forEach(tech => {
        if (!byMethods[tech.methodCode]) {
          byMethods[tech.methodCode] = [];
        }
        byMethods[tech.methodCode].push(tech);
      });

      return {
        matrix: matrix,
        foaList: Object.keys(byMethods).map(method => ({
          method: method,
          foas: byMethods[method]
        }))
      };
    });
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Foa_Report.pdf');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
